import { EyeOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import moment from 'moment';

import type { ModelNeuralNetworkLogsResult } from '@app/api/NeuralNetworkLogs';

import type { GetColumnType } from '@pages/NeuralNetworkLogs/types';

import type { ColumnsType } from 'antd/es/table';

const trimOneLine = (s?: string, max = 140) =>
  (s ?? '').replace(/\s+/g, ' ').trim().slice(0, max);

export const getNeuralNetworkLogsColumns: GetColumnType = ({ openLog }) => {
  const columns: ColumnsType<ModelNeuralNetworkLogsResult> = [
    {
      title: 'Дата время',
      dataIndex: 'TimestampUtc',
      key: 'TimestampUtc',
      width: 150,
      render: (date: ModelNeuralNetworkLogsResult['TimestampUtc']) => (
        <span className="no-wrap-text">
          {moment(date).format('DD.MM.YYYY HH:mm')}
        </span>
      ),
      fixed: 'left',
    },
    {
      title: 'Организация',
      dataIndex: 'OrganizationName',
      key: 'OrganizationName',
      width: 200,
      render: (text: ModelNeuralNetworkLogsResult['OrganizationName']) => (
        <span className="no-wrap-text">{text}</span>
      ),
    },
    {
      title: 'Провайдер',
      dataIndex: 'Provider',
      key: 'Provider',
      width: 160,
      render: (text: ModelNeuralNetworkLogsResult['Provider']) => (
        <span className="no-wrap-text">{text}</span>
      ),
    },
    {
      title: 'Модель',
      dataIndex: 'Model',
      key: 'Model',
      width: 160,
      render: (text: ModelNeuralNetworkLogsResult['Model']) => (
        <span className="no-wrap-text">{text}</span>
      ),
    },
    {
      title: 'Сущность, ID',
      dataIndex: 'EntityId',
      key: 'EntityId',
      width: 160,
      render: (text: ModelNeuralNetworkLogsResult['EntityId']) => (
        <span className="no-wrap-text">{text}</span>
      ),
    },
    {
      title: 'Запрос',
      dataIndex: 'Request',
      key: 'Request',
      width: 380,
      ellipsis: { showTitle: false },
      render: (text: string | undefined) => (
        <span className="truncate-two-lines">{trimOneLine(text)}</span>
      ),
    },
    {
      title: 'Ответ',
      dataIndex: 'Response',
      key: 'Response',
      width: 420,
      ellipsis: { showTitle: false },
      render: (text: string | undefined) => (
        <span className="truncate-two-lines">{trimOneLine(text)}</span>
      ),
    },
    {
      title: 'GPT',
      key: 'Gpt',
      width: 180,
      render: (_, r) => (
        <span className="no-wrap-text">
          {[r.Provider, r.Model].filter(Boolean).join(' ')}
        </span>
      ),
    },
    {
      title: 'Расход, вход/исх',
      key: 'Tokens',
      width: 140,
      align: 'center',
      render: (_, r) => (
        <span className="no-wrap-text">
          {r.InputTokens ?? 0}/{r.OutputTokens ?? 0}
        </span>
      ),
    },
    {
      title: '',
      key: 'actions',
      width: 56,
      fixed: 'right',
      align: 'center',
      render: (_, log) => (
        <Button
          type="text"
          icon={<EyeOutlined />}
          onClick={() => openLog(log)}
        />
      ),
    },
  ];

  return columns;
};
